import DeleteIcon from "@material-ui/icons/Delete";

const nonEditableLabels = [
  "CVE per Day",
  "Insurance per Day",
];

function DailyExpensesModal({
  dailyExpenses: propDailyExpenses = [
    { label: "CVE per Day", value: "" },
    { label: "Insurance per Day", value: "" },
  ],
  setCalculatorData = () => { },
  calculatorData = {},
}) {
  const dailyExpenses =
    propDailyExpenses && propDailyExpenses.length > 0
      ? propDailyExpenses
      : [
        { label: "CVE per Day", value: "" },
        { label: "Insurance per Day", value: "" },
      ];

  const onChangeDailyExpensesField = (index, field, newValue) => {
    const existingFields = calculatorData?.clientQuery?.dailyExpenses || dailyExpenses;
    const updatedFields = [...existingFields];
    if (!updatedFields[index]) return;

    updatedFields[index] = {
      ...updatedFields[index],
      [field]: field === "value" ? (newValue === "" ? "" : Number(newValue)) : newValue,
    };

    setCalculatorData((prev) => ({
      ...prev,
      clientQuery: {
        ...prev?.clientQuery,
        dailyExpenses: updatedFields,
      },
    }));
  };

  const addNewDailyExpensesField = () => {
    const existingFields = calculatorData?.clientQuery?.dailyExpenses || dailyExpenses;
    const updatedFields = [...existingFields, { label: "", value: "" }];

    setCalculatorData((prev) => ({
      ...prev,
      clientQuery: {
        ...prev?.clientQuery,
        dailyExpenses: updatedFields,
      },
    }));
  };

  const deleteDailyExpensesField = (index) => {
    const existingFields = calculatorData?.clientQuery?.dailyExpenses || dailyExpenses;
    if (index < 2 || index >= existingFields.length) return;

    const updatedFields = [...existingFields];
    updatedFields.splice(index, 1);

    setCalculatorData((prev) => ({
      ...prev,
      clientQuery: {
        ...prev?.clientQuery,
        dailyExpenses: updatedFields,
      },
    }));
  };

  return (
    <div className="p-0.5">
      <table
        className="w-full border-collapse text-[11px]"
        style={{ border: "1px solid #cbd5e1" }}
      >
        <thead>
          <tr className="bg-[#f0f2f5]">
            <th
              className="text-left font-semibold text-slate-700 px-2 py-1 text-[11px]"
              style={{ border: "1px solid #cbd5e1", width: "50%" }}
            >
              Label
            </th>
            <th
              className="text-left font-semibold text-slate-700 px-2 py-1 text-[11px]"
              style={{ border: "1px solid #cbd5e1", width: "35%" }}
            >
              Value
            </th>
            <th
              className="text-center font-semibold text-slate-700 px-2 py-1 text-[11px]"
              style={{ border: "1px solid #cbd5e1", width: "15%" }}
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {dailyExpenses.map((item, index) => {
            const isFixed = nonEditableLabels.includes(item.label);
            return (
              <tr key={index}>
                <td
                  className="p-0 bg-[#ffffd6]"
                  style={{ border: "1px solid #cbd5e1" }}
                >
                  <input
                    type="text"
                    value={item.label ?? ""}
                    disabled={isFixed}
                    placeholder="Label"
                    onChange={(e) =>
                      onChangeDailyExpensesField(index, "label", e.target.value)
                    }
                    className="w-full h-[22px] px-1.5 text-[11px] bg-[#ffffd6] text-slate-800 outline-none border-none disabled:bg-white disabled:text-slate-700"
                  />
                </td>
                <td
                  className="p-0 bg-[#ffffd6]"
                  style={{ border: "1px solid #cbd5e1" }}
                >
                  <input
                    type="number"
                    value={
                      item.value === 0 || item.value === ""
                        ? ""
                        : item.value ?? ""
                    }
                    placeholder=""
                    onChange={(e) =>
                      onChangeDailyExpensesField(index, "value", e.target.value)
                    }
                    className="w-full h-[22px] px-1.5 text-[11px] bg-[#ffffd6] text-slate-800 outline-none border-none"
                  />
                </td>
                <td
                  className="p-0 text-center bg-white align-middle"
                  style={{ border: "1px solid #cbd5e1" }}
                >
                  {isFixed ? (
                    <span className="text-slate-500 font-medium text-[11px]">—</span>
                  ) : (
                    <DeleteIcon
                      style={{ cursor: "pointer", color: "blue", fontSize: 15 }}
                      onClick={() => deleteDailyExpensesField(index)}
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <button
        type="button"
        onClick={addNewDailyExpensesField}
        className="mt-2.5 px-2.5 py-1 bg-[#313C4C] text-white text-[11px] font-semibold rounded hover:bg-[#0c2f50] transition-colors cursor-pointer"
      >
        + Add
      </button>
    </div>
  );
}

export default DailyExpensesModal;
